import React from "react";
import {
  Box,
  TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const factoryItemList = this.props.factoryItemList;
    const searchData = this.props.searchData;
    const validData=this.props.validData;
    const allColumnNames = this.props.columnNames

    return (
      <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', padding: '20px' }}>
        <h3><center><u>Factory Items Removal Report</u></center></h3>
        <h4><center>Group :{ searchData.groupName }</center></h4>
        <h4><center>Factory :{ searchData.factoryName }</center></h4>
        <h4><center>From :{validData.startDate}  -  To :{validData.endDate}</center></h4>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050}>
            <TableContainer style={{ marginLeft: '5px' }}>
              <Table aria-label="caption table" style={{ borderCollapse: 'collapse', width: '99%' }} >
                <TableHead>
                  <TableRow style={{ border: '1px solid black' }}>
                    {
                      allColumnNames.map((object) => {
                        return (
                          <TableCell align={'left'} style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>{object.title}</TableCell>
                        )
                      })
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {factoryItemList.map((data, index) => (
                    <TableRow key={index} style={{ border: '1px solid black' }}>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.issuingDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.modifiedDate.split('T')[0]}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.itemName}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black' ,textAlign: 'right', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                      <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid black', padding: '2px 6px', fontSize: '0.9rem' }}>
                        {data.userName}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </div>
      </div>
    );
  }
}
